export enum HavingDealType {
    None = 'None',
    BdHavingDeals = 'BdHavingDeals',
    CmHavingAllPublishedDeals = 'CmHavingAllPublishedDeals',
    CloManagers = 'CloManagers',
    Banks = 'Banks',
}
